/**
 文件描述：公共工具类
 创建人：殷俊
 创建时间：2020-06-24
 */
const rv_common = {
    /**
     是否为空
     @param {String}a 变量
     @return 是否为空
     */
    isEmpty(a) {
        if (a === undefined || a === 'undefined' || a === null || a === 'null' || a === '' || JSON.stringify(a) === '{}' || JSON.stringify(a) === '[]') {
            return true
        } else {
            return false
        }
    },

    /**
     是否不为空
     @param {String}a 变量
     @return 是否为空
     */
    isNotEmpty(a) {
        if (a === undefined || a === 'undefined' || a === null || a === 'null' || a === '' || JSON.stringify(a) === '{}' || JSON.stringify(a) === '[]') {
            return false
        } else {
            return true
        }
    },

    /**
     日期反格式化
     @param {String}dateStr 日期
     @param {String}format 分隔符
     @return {Date} 新格式日期
     */
    parseDate(dateStr, separator) {
        if (!separator) {
            separator = '-'
        }
        const dateArr = dateStr.split(separator)
        const year = parseInt(dateArr[0])
        let month
        if (dateArr[1].indexOf('0') === 0) {
            month = parseInt(dateArr[1].substring(1))
        } else {
            month = parseInt(dateArr[1])
        }
        const day = parseInt(dateArr[2])
        return new Date(year, month - 1, day)
    },

    /**
     去除字符串左右空格
     @param {String}str 原字符串
     @return {String} 去除左右空格后的字符串
     */
    trimStr(str) {
        if (str === undefined || str === 'undefined') {
            return ''
        }
        if (typeof (str) === 'number') {
            str = str.toString()
        }
        return str.replace(/^(\s|\u00A0)+/, '').replace(/(\s|\u00A0)+$/, '')
    },

    /**
     获取cookie参数
     @param {String}key 参数名
     @return {String} 参数值
     */
    getCookie(key) {
        const cookieArr = document.cookie.split(';')
        for (let i = 0; i < cookieArr.length; i++) {
            const arr = cookieArr[i].split('=')
            if (this.trimStr(arr[0]) === key) {
                return arr[1]
            }
        }
        return ''
    },

    /**
     获取链接参数
     @param
     @return {String} 参数值
     */
    etParameter(param) {
        const h = window.location.hash.substr(1)
        const i = h.indexOf('?') < 0 ? h.length : h.indexOf('?')
        const r = h.substr(i + 1).match(new RegExp('(^|&)' + param + '=([^&]*)(&|$)', 'i'))
        if (r != null) {
            return r[2]
        } else {
            return ''
        }
    },

    /**
     * 是否移动端微信、qq浏览器
     * @param
     * @return
     */
    isWeiChartBrowser() {
        let u = navigator.userAgent;
        // let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端

        let ua = navigator.userAgent.toLowerCase();
        let isWeixin = ua.match(/MicroMessenger/i) == 'micromessenger'; // 微信浏览器
        let isQQ = ua.indexOf('qqbrowser') > -1; // 是否为 QQ

        let clientWidth = document.documentElement.clientWidth; // 窗口宽度
        // svg版本
        if((isAndroid && (isWeixin || isQQ)) || (clientWidth > 550 && clientWidth < 850)) {
            return true;
        }else {
            return false;
        }
    },

    /**
     * 是否移动端
     * @param
     * @return
     */
    isMobile() {
        let u = navigator.userAgent;
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
        if(isiOS || isAndroid) {
            return true;
        }else {
            return false;
        }
    }
}

export {rv_common}



// WEBPACK FOOTER //
// ./src/utils/common.js